import React, { Component } from 'react';
import Event from "./../../../../../assets/PubJs/hcPub"//所有事件

import { connect } from "react-redux"//联系store的组件
import evn from "./../../../../../actions/index"//action的所有事件

import 'ant-design-pro/dist/ant-design-pro.css';
import './style.css';
import Result from 'ant-design-pro/lib/Result';
import { Radio, Modal, Form, Input, message, Icon, Upload, Button } from 'antd';//引入antd组件
import img from './../../../../../assets/images/noCompany.png';//无内容图片
import yyzz from './../../../../../assets/images/yyzz.png';//营业执照图片
import CompanyModal from "./../CompanyModal/index"//组件携带参数“0”或者“1”，0为有切换用户，1无切换用户
import $ from "jquery"
import EventSet from "./../../../../../assets/PubJs/hcPub"//公用的所有事件
import { Hcurl } from "./../../../../../constants/index"//获取公共路径
import createHistory from 'history/createHashHistory';//路由切换地址
const history = createHistory();//定义history路由
const FormItem = Form.Item;


//图片上传
let _PicturesWall = null
class PicturesWall extends React.Component {
    state = {
        previewVisible: false,
        previewImage: '',
        fileList: [],
    };

    handleCancel = () => this.setState({ previewVisible: false })

    //图片预览事件
    handlePreview = (file) => {
        //console.log(file)
        this.setState({
            previewImage: file.response,
            previewVisible: true,
        })
    }
    //营业执照预览事件
    handleYyzzPreview = (file) => {
        this.setState({
            previewImage: yyzz,
            previewVisible: true,
        })
    }

    //图片改变事件
    handleChange = ({ file, fileList, event }) => {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            message.error('图片大小不能大于5M');
        } else {
            if (file.status === 'done') {
                message.success(`${file.name} 文件上传成功`);

            } else if (file.status === 'error') {
                message.error(`${file.name} 文件上传失败`);
            }
            // console.log(fileList)
            this.setState({ fileList })
        }
    }

    //图片上传前事件
    beforeUpload = (file) => {
        let arr = ['jpeg', 'png', 'bmp', 'jpg' ].includes(file.type.split('/')[1])
        return new Promise((resolve, reject) => {
            const isLt2M = file.size / 1024 / 1024 < 10;
            const svgType = file.type.indexOf('svg') == -1;
    
            if (!isLt2M) {
                message.error('单个附件大小最多10M');
                return reject(false)
            }
            else {
                this.setState({ dataName: file.name })
            }
            // 去除svg
            if(!svgType){
                message.error('请上传正确的文件格式');
                return reject(false)
            }
            if (!arr) {
                message.error('请上传正确的文件格式');
                return reject(false)
            }
            return resolve(true);
        })
        
    }

    componentDidMount() {
        _PicturesWall = this
    }

    render() {
        const { previewVisible, previewImage, fileList } = this.state;
        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text">上传</div>
            </div>
        );
        const head = { 'X-Requested-With': null }
        return (
            <div className="clearfix">
                <Upload
                    name="file"
                    accept="image/jpg,image/jpeg,image/png,image/bmp"
                    // action={"https://webservice.jshcsoft.com/upload/UpLoadFile/UploadHandler.ashx"}
                    action={"https://wisdom.jsca315.org.cn/wisdom315_BusinessAPI_jiangsu/api/HomePage/Uploadfile"}
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={this.handlePreview}
                    beforeUpload={this.beforeUpload}
                    onChange={this.handleChange}
                    headers={head}
                >
                    {fileList.length >= 1 ? null : uploadButton}
                </Upload>
                <div className={"yyzz"}>
                    <div className={"yyzzmask"}><Icon onClick={() => this.handleYyzzPreview()} type="eye-o" /></div>
                    <img alt="" style={{ height: '80%' }} src={yyzz} />
                    <p style={{ lineHeight: "20px", margin:0 }}>示例图</p>
                </div>
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                </Modal>
            </div>
        );
    }
}

//绑定企业组件
let _NormalLoginForm = null;
class NormalLoginForm extends React.Component {
    state = {
        loading: false,
        result: false,
    }

    //表单提交
    handleSubmit = (e) => {
        e.preventDefault();
        let imageUrl = ""
        $.each(_PicturesWall.state.fileList, function (idx, txt) {
            imageUrl += txt.response
        })
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (imageUrl === "") {
                    message.warn("请选择上传的营业执照")
                    return
                }
                _NormalLoginForm.setState({
                    loading: true
                })
                let setData = {
                    UserCode: Event.getUserInfo().CU_Code,
                    CreditCode: values.xydm,
                    CompanyName: values.qymc,
                    Header: values.fddbrxm,
                   // LawCardNo: values.fddbrzjh,
                    FileUrl: imageUrl,
                    Type: "3"
                };
                //console.log(setData)
                $.ajax({
                    url: Hcurl+"/CompanyCore/AddCompany",
                    type: "post",
                    data: setData,
                    async: false,
                    headers: {
                        "token": EventSet.getUserInfo()['token']
                    },
                    success: function (res) {
                        //console.log(res);
                        _NormalLoginForm.setState({
                            loading: false,
                        })
                        if (res.split("|")[0] == "false") {
                            message.error(res.split("|")[1]);
                        } else {
                            _App.setState({
                                result: true,
                                name: setData.CompanyName
                            })
                        }
                    },
                    error: function (data, err) {
                        if (!JSON.parse(data.responseText).success && data.status === 403) {
                            history.push({ "pathname": "/err" })
                        } else {
                            message.error(err)
                        }
                    }
                })
            } else {
                message.warn("请检查后重新尝试")
            }
        });
    };
    //组件完成
    componentDidMount() {
        _NormalLoginForm = this
    }

    //组件渲染
    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                md: { span: 6 },
            },
            wrapperCol: {
                md: { span: 18 },
            },
        };
        return (
            <div className={""}>
                <div style={{ padding: "32px 24px 0", textAlign: "left" }}>
                    <h2 style={{ textAlign: "center" }}>企业绑定申诉</h2>
                    <Form onSubmit={this.handleSubmit} className="login-form">
                        <FormItem
                            {...formItemLayout}
                            label="信用代码"
                        >
                            {getFieldDecorator('xydm', {
                                rules: [{ required: true, message: '请输入统一社会信用代码/注册号' }],
                            })(
                                <Input placeholder="请输入统一社会信用代码/注册号" />
                                )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="企业名称"
                        >
                            {getFieldDecorator('qymc', {
                                rules: [{ required: true, message: '请输入企业全称' }],
                            })(
                                <Input  placeholder="请输入企业全称" />
                                )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="法定代表人姓名"
                        >
                            {getFieldDecorator('fddbrxm', {
                                rules: [{ required: true, message: '请输入法定代表人（负责人）姓名' }],
                            })(
                                <Input  placeholder="请输入法定代表人（负责人）姓名" />
                                )}
                        </FormItem>
                        {/*
                         <FormItem
                            {...formItemLayout}
                            label="法定代表人证件号"
                        >
                            {getFieldDecorator('fddbrzjh', {
                                rules: [
                                    { required: true, message: '请输入法定代表人证件号码' },
                                    { pattern: /^[A-Za-z0-9]{15,18}$/, message: '请输入有效的证件号' },
                                ],
                            })(
                                <Input maxLength={18} placeholder="请输入法定代表人证件号码，15-18位" />
                                )}
                        </FormItem>
                         */}
                        <FormItem
                            {...formItemLayout}
                            label={<span style={{ color: "rgba(0, 0, 0, 0.85)", fontSize: 14 }}><span style={{ position: "relative", top: "5px", color: "#f00", fontSize: 20 }}>* </span>营业执照 </span>}
                        >
                            {getFieldDecorator('img', {
                                rules: [{ required: false }],
                            })(
                                <PicturesWall />
                                )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="&nbsp;"
                            colon={false}
                        >
                            <span style={{ color: "rgba(0, 0, 0, 0.45)", fontSize: 14 }}>（支持JPG、PNG、BMP格式的图片文件、文件小于5M；营业执照尽量上传彩色照片，复印件请加盖彩色公章）</span>

                        </FormItem>

                        <p style={{ textAlign: "center" }}> <Button loading={this.state.loading} onClick={this.handleSubmit} type="primary" htmlType="submit">提交申请</Button></p>
                    </Form>
                </div>
            </div>

        );
    }
}
const WrappedNormalLoginForm = Form.create()(NormalLoginForm);

let _App = null;
class App extends Component {

    state = {
        hei: 500,
        result: false,
        name:""
    };

    //窗体大小
    windowChangeSize() {
        let H = window.innerHeight - 229;

        this.setState({
            hei: H < 400 ? 400 : H
        })
    }

      //弹出切换绑定企业弹框
    showModal() {
        this.props.dispatch(evn.showModal())
    }
    close() {
        window.opener = null;
        window.open('', '_self');
        window.close();
    }

    //组件完成后
    componentDidMount() {
        _App = this;
        this.windowChangeSize()
    }
    render() {
        //console.log(this.state.name, "name1")
        return (
            <div style={{ minWidth: 760 }}>
                <div style={{ minHeight: this.state.hei, position: "relative" }}>

                    {
                        this.state.result ? <Result
                            type="success"
                            title="企业绑定申诉提交成功"
                            description={"您好，您对“" + this.state.name+"”的申诉已提交成功，平台工作人员正在进行审核，审核结束后我们会通过短信通知您，请耐心等待！"}
                            actions={<Button type="primary" onClick={this.close} >关闭页面</Button>}
                            style={{
                                position: "absolute",
                                width: "100%",
                                top: "20%",
                            }}
                        /> : <div style={{ width: "44%", margin: "0 auto", minWidth: "660px" }}>
                                <WrappedNormalLoginForm />
                            </div>
                    }
                </div>
            </div>
        );
    }
}

export default connect()(App)


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyCenter/Statement/Statement.js